import React from 'react';
import ClientAccounts from './ClientAccounts';

export default function ClientHub() {
  return <ClientAccounts />;
}
